<p-toast [position]="toastPosition">
  <ng-template
    pTemplate="headless"
    let-message>
    <div
      class="flex gap-3 overflow-hidden rounded-none border px-3 py-3 md:rounded-lg md:py-1.5"
      [ngClass]="{
        'border-line-success-bold bg-bg-success-subtlest-default':
          message.severity === ToastSeverityType.SUCCESS,
        'border-line-danger-bold bg-bg-danger-subtlest-default':
          message.severity === ToastSeverityType.ERROR,
        'border-line-warning-bold bg-bg-warning-subtlest-default':
          message.severity === ToastSeverityType.WARN,
        'border-line-info-bold bg-bg-info-subtlest-default':
          message.severity === ToastSeverityType.INFO,
      }">
      <div>
        <ng-container [ngSwitch]="message.severity">
          <ng-container *ngSwitchCase="ToastSeverityType.SUCCESS">
            <ic-tick-circle-outline class="text-text-success inline-block h-4 w-4" />
          </ng-container>
          <ng-container *ngSwitchCase="ToastSeverityType.ERROR">
            <ic-close-circle-outline class="text-text-danger inline-block h-4 w-4" />
          </ng-container>
          <ng-container *ngSwitchCase="ToastSeverityType.WARN">
            <ic-warning-triangle-outline class="text-text-warning inline-block h-4 w-4" />
          </ng-container>
          <ng-container *ngSwitchCase="ToastSeverityType.INFO">
            <ic-warning-circle-outline class="text-text-info inline-block h-4 w-4" />
          </ng-container>
        </ng-container>
      </div>
      <div class="flex grow flex-col gap-1">
        <p
          class="text-0.5xs font-bold"
          [ngClass]="{
            'text-text-success': message.severity === ToastSeverityType.SUCCESS,
            'text-text-danger': message.severity === ToastSeverityType.ERROR,
            'text-text-warning': message.severity === ToastSeverityType.WARN,
            'text-text-info': message.severity === ToastSeverityType.INFO,
          }">
          {{ message.summary }}
        </p>
        @if (message.detail) {
          <p class="text-1.5xs">
            {{ message.detail }}
          </p>
        }
      </div>
      <button
        class="block h-max"
        (click)="messageService.clear()">
        <ic-close-outline
          class="inline-block h-4 w-4"
          [ngClass]="{
            'text-text-success': message.severity === ToastSeverityType.SUCCESS,
            'text-text-danger': message.severity === ToastSeverityType.ERROR,
            'text-text-warning': message.severity === ToastSeverityType.WARN,
            'text-text-info': message.severity === ToastSeverityType.INFO,
          }" />
      </button>
    </div>
  </ng-template>
</p-toast>
